import React, { useState, useEffect, useCallback } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function ViewComplaints() {
  const [phone, setPhone] = useState(localStorage.getItem("phone") || "");
  const [complaints, setComplaints] = useState(
    JSON.parse(localStorage.getItem("complaints") || "[]")
  );
  const [loading, setLoading] = useState(false);

  // ✅ useCallback ensures function is stable (not recreated every render)
  const fetchComplaints = useCallback(
    async (fromInterval = false) => {
      if (!phone) return;

      if (!fromInterval) setLoading(true);

      try {
        const res = await fetch(AIRTABLE_URL, {
          headers: AIRTABLE_HEADERS,
        });

        const json = await res.json();
        const records = json.records || [];

        const customerPhone = phone.replace(/\s+/g, "").trim();

        const filtered = records
          .filter(
            (item) =>
              item.fields.phone?.replace(/\s+/g, "").trim() === customerPhone &&
              (item.fields.complaint ||
                item.fields.complaintAgain ||
                item.fields.complaintAgain3)
          )
          .map((item) => item.fields);

        setComplaints(filtered);
        localStorage.setItem("complaints", JSON.stringify(filtered));
      } catch (err) {
        console.error("❌ Error fetching complaints from Airtable:", err);
        if (!fromInterval) alert("❌ Error fetching complaints");
      } finally {
        if (!fromInterval) setLoading(false);
      }
    },
    [phone] // 👈 phone dependency zaroori hai
  );

  // ✅ Run once when technicianPhone exists
  useEffect(() => {
    const technicianPhone = localStorage.getItem("technicianPhone");
    if (technicianPhone) {
      fetchComplaints();
    }
  }, [fetchComplaints]);

  // ✅ Auto-refresh every 10s if technicianPhone exists
  useEffect(() => {
    const technicianPhone = localStorage.getItem("technicianPhone");
    if (technicianPhone) {
      const interval = setInterval(() => fetchComplaints(true), 10000);
      return () => clearInterval(interval);
    }
  }, [fetchComplaints]);

  const handleSearch = () => {
    localStorage.setItem("phone", phone);
    fetchComplaints();
  };

  return (
    <div style={{ padding: 30, maxWidth: 700, margin: "auto" }}>
      <h3>📂 Your Complaints</h3>

      <input
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={10}
        placeholder="📱 Enter your phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        style={{ width: "100%", padding: 10, marginBottom: 10 }}
      />

      <button
        onClick={handleSearch}
        style={{
          marginBottom: 20,
          backgroundColor: "#007bff",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
        }}
      >
        🔍 Search Complaints
      </button>

      {loading && <p>⏳ Loading...</p>}

      {!loading && complaints.length === 0 && (
        <p>No complaints found for this number.</p>
      )}

      {complaints.map((item, idx) => {
  let displayComplaint = null;

  const status1 = item.complaintStatus?.trim();
  const status2 = item.complaintStatusAgain?.trim();
  const status3 = item.complaintStatusAgain3?.trim();

  console.log("📦 Full record:", item);
  console.log("📊 status1:", status1, "| status2:", status2, "| status3:", status3);

  if (status1 === "Pending" && !status2) {
    displayComplaint = {
      assignedTechnicianPhone: item.assignedTechnicianPhone,
      orderId: item.orderId,
      category: item.complaintCategory,
      status: status1,
      complaint: item.complaint,
      response: item.complaintResponse || "⏳ Waiting for technician response",
    };
  } else if (status1 === "Resolved" && status2 === "Pending") {
    displayComplaint = {
      assignedTechnicianPhone: item.assignedTechnicianPhone,
      orderId: item.orderId,
      category: item.complaintCategoryAgain,
      status: status2,
      complaint: item.complaintAgain || "Not Provided",
      response: item.complaintResponseAgain || "⏳ Waiting for technician response",
    };
  } else if (status1 === "Resolved" && status2 === "Resolved" && status3 === "Pending") {
    displayComplaint = {
      assignedTechnicianPhone: item.assignedTechnicianPhone,
      orderId: item.orderId,
      category: item.complaintCategoryAgain3,
      status: status3,
      complaint: item.complaintAgain3 || "Not Provided",
      response: item.complaintResponseAgain3 || "⏳ Waiting for technician response",
    };
  } else if (status3 === "Resolved") {
    displayComplaint = {
      assignedTechnicianPhone: item.assignedTechnicianPhone,
      orderId: item.orderId,
      category: item.complaintCategoryAgain3,
      status: status3,
      complaint: item.complaintAgain3 || "Not Provided",
      response: item.complaintResponseAgain3 || "✅ Resolved",
    };
  }

  return displayComplaint ? (
    <div
      key={idx}
      style={{
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: 15,
        marginBottom: 10,
        backgroundColor: "#f9f9f9",
      }}
    > <p><b>Technician Number:</b> {displayComplaint.assignedTechnicianPhone}</p>
      <p><b>Order ID:</b> {displayComplaint.orderId}</p>
      <p><b>Category:</b> {displayComplaint.category}</p>
      <p><b>Status:</b> {displayComplaint.status}</p>
      <p><b>Complaint:</b> {displayComplaint.complaint}</p>
      <p><b>Technician Response:</b> {displayComplaint.response}</p>
      <p><b>Solution:</b> {displayComplaint.response}</p>
          </div>
        ) : null;
      })}
    </div>
  );
}
